/**
 * @generated SignedSource<<74766e77c5be6c13d62c0ae48397b923>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enable",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateBusinessPayload",
    "kind": "LinkedField",
    "name": "updateBusiness",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Business",
        "kind": "LinkedField",
        "name": "business",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "businessId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocaleGroup",
            "kind": "LinkedField",
            "name": "localeGroups",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locales",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "default",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatConfiguration",
            "kind": "LinkedField",
            "name": "chatConfiguration",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "themeColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customCss",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showAgentProfile",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Localised",
                "kind": "LinkedField",
                "name": "localised",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "localeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersistentMenuSettings",
                    "kind": "LinkedField",
                    "name": "persistentMenu",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "buttons",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IceBreakersSettings",
                    "kind": "LinkedField",
                    "name": "iceBreakers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctas",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LocaleGroupsSettings_updateBusinessMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LocaleGroupsSettings_updateBusinessMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "226f4973d7c510ba98703a98e48e0a91",
    "id": null,
    "metadata": {},
    "name": "LocaleGroupsSettings_updateBusinessMutation",
    "operationKind": "mutation",
    "text": "mutation LocaleGroupsSettings_updateBusinessMutation(\n  $input: UpdateBusinessInput!\n) {\n  updateBusiness(input: $input) {\n    business {\n      id\n      businessId\n      localeGroups {\n        id\n        name\n        locales\n        default\n      }\n      chatConfiguration {\n        themeColor\n        customCss\n        showAgentProfile\n        localised {\n          localeId\n          persistentMenu {\n            buttons\n            enable\n          }\n          iceBreakers {\n            ctas\n            enable\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c47128a74fcba4fd9928d0281e70489d";

module.exports = node;
